// Settings.js
import React, { useState } from 'react';
import './css/Settings.css';

function Settings() {
    const [breakfastOpenTime, setBreakfastOpenTime] = useState("07:00 AM");
    const [breakfastCloseTime, setBreakfastCloseTime] = useState("10:00 AM");
    const [lunchOpenTime, setLunchOpenTime] = useState("12:00 PM");
    const [lunchCloseTime, setLunchCloseTime] = useState("03:00 PM");
    const [dinnerOpenTime, setDinnerOpenTime] = useState("06:00 PM");
    const [dinnerCloseTime, setDinnerCloseTime] = useState("10:00 PM");

    const handleBreakfastOpenTimeChange = (event) => setBreakfastOpenTime(event.target.value);
    const handleBreakfastCloseTimeChange = (event) => setBreakfastCloseTime(event.target.value);
    const handleLunchOpenTimeChange = (event) => setLunchOpenTime(event.target.value);
    const handleLunchCloseTimeChange = (event) => setLunchCloseTime(event.target.value);
    const handleDinnerOpenTimeChange = (event) => setDinnerOpenTime(event.target.value);
    const handleDinnerCloseTimeChange = (event) => setDinnerCloseTime(event.target.value);

    const handleSubmit = (event) => {
        event.preventDefault();
        alert(`Settings Saved:
        Breakfast - Open Time: ${breakfastOpenTime}, Close Time: ${breakfastCloseTime}
        Lunch - Open Time: ${lunchOpenTime}, Close Time: ${lunchCloseTime}
        Dinner - Open Time: ${dinnerOpenTime}, Close Time: ${dinnerCloseTime}`);
    };

    return (
        <div className="settings-container">
            <h2>Restaurant Time Settings</h2>
            

<form onSubmit={handleSubmit}>
    <div className="session-row">
        <div className="session">
            <h3>Breakfast</h3>
            <label>Opening Time: </label>
            <input type="time" value={breakfastOpenTime} onChange={handleBreakfastOpenTimeChange} />
            <label>Closing Time: </label>
            <input type="time" value={breakfastCloseTime} onChange={handleBreakfastCloseTimeChange} />
        </div>

        <div className="session">
            <h3>Lunch</h3>
            <label>Opening Time: </label>
            <input type="time" value={lunchOpenTime} onChange={handleLunchOpenTimeChange} />
            <label>Closing Time: </label>
            <input type="time" value={lunchCloseTime} onChange={handleLunchCloseTimeChange} />
        </div>

        <div className="session">
            <h3>Dinner</h3>
            <label>Opening Time: </label>
            <input type="time" value={dinnerOpenTime} onChange={handleDinnerOpenTimeChange} />
            <label>Closing Time: </label>
            <input type="time" value={dinnerCloseTime} onChange={handleDinnerCloseTimeChange} />
        </div>
    </div>

    <button type="submit">Save Settings</button>
</form>


            <div className="current-settings">
                <h3>Current Settings</h3>
                <p>Breakfast - Open Time: {breakfastOpenTime}, Close Time: {breakfastCloseTime}</p>
                <p>Lunch - Open Time: {lunchOpenTime}, Close Time: {lunchCloseTime}</p>
                <p>Dinner - Open Time: {dinnerOpenTime}, Close Time: {dinnerCloseTime}</p>
            </div>
        </div>
    );
}

export default Settings;
